module.exports = __webpack_public_path__ + "img/acc9b42529a8df92844d8e34c1bbf291.png";